module.exports = __webpack_public_path__ + "static/photo4-96bbe38d2340d79f06cc2fc9ccb38db4.png";